import React, { useState, useContext  } from "react"
import { style_templates } from "../config_variables/styles"
import { View, Button,  StatusBar, Pressable, FlatList, useWindowDimensions } from "react-native"
import Card from "../components/Card"
import { variables } from "../config_variables/variables"
import { DataContext } from "../store/data-context"
import convertMapToArray from "../utils/convertMapToArray";



function LotsListScreen({route, navigation}) {
      console.log("inside lotsList");
      const { height, width } = useWindowDimensions();
      const dataCtx = useContext(DataContext);

      console.log('dataCtx.currentMetric: ' + dataCtx.currentMetric)
      console.log("route.params : " +  JSON.stringify(route.params))
      console.log("route.params.screendataarray : " +  JSON.stringify(route.params.screendataarray))
      dataCtx.setMoveToLotsScreen(false)
      dataCtx.setfiltercategory("lot")
      console.log('dataCtx.summarizeAs : ' + dataCtx.summarizeAs)
      console.log('dataCtx.filteritems: ' + JSON.stringify(dataCtx.filteritems))
      const filteritems_array = convertMapToArray(dataCtx.filteritems)
      console.log('filteritems_array: ' + JSON.stringify(filteritems_array))


      filteritems_array.map((f) => {
            if( f.value.length != 0 ) {
                  console.log('filter selected - category: ' + f.fieldapiname)
                  f.value.map( (fa) => (
                        console.log('filter selected - item: ' + fa.sfname)
                  ))
            }
      })

      const temp_array = []
      route.params.screendataarray.map((s) => {
            temp_array.push({...s})
      })

      console.log('temp_array : ' + JSON.stringify(temp_array))
      

      route.params.screendataarray.map((m) => {
      let temp_total_value = route.params.screendataarray.find((d) => d.fieldapiname === m.fieldapiname).value
      if(  ( m.fieldapiname.includes('value') ) || ( m.fieldapiname.includes('price') ) || ( m.fieldapiname.includes('valuation') )) {
            temp_array.find((s) => s.fieldapiname === m.fieldapiname).value = "$ " + (temp_total_value  / 1000000).toFixed(2) + " M"
      }
      if( m.fieldapiname.includes('size')) {
            temp_array.find((s) => s.fieldapiname === m.fieldapiname).value = (temp_total_value  / 1000).toFixed(2) + " K sq m"
      }
})

console.log('temp_array after unit conversion: ' + JSON.stringify(temp_array))

  function renderCards(itemData) {
      // console.log('inside renderCards')
      // console.log('dataCtx.filtercategory: ' + dataCtx.filtercategory)
      console.log('itemData.item: ' + JSON.stringify(itemData.item))
      return (
            <Card
            filtercategory={dataCtx.filtercategory}
            cardData={itemData.item}
            WINDOW_HEIGHT={height}
            showLotsHandler={dataCtx.showLotsHandler}
            />
      )
  }

function backToSummaryScreen() {
      dataCtx.setfiltercategory("tranche")
      
      navigation.navigate("screen2OverallSummary", {
    });
}

console.log('dataCtx.cardListData: ' + JSON.stringify(dataCtx.cardListData))


   return (
    <View style={style_templates.app_container}>
      <View style={style_templates.app_body_container}>
        <StatusBar animated={true} backgroundColor="#61dafb" />
                  {/* <View style={[style_templates.app_sub_container_header, {flex:2, marginTop:50,}]}> */}
                        <View style={[style_templates.app_sub_container_header, {flex:1, backgroundColor: "rgb(82, 72, 107)"}]}>

                        <>
                              {/* <View style={style_templates.app_sub_container_header_row_container}>
                                    {variables.screen2_metrics_row_1.map((m) => (
                                          <>
                                                {      ( m.metric ==  dataCtx.currentMetric || m.metric == "") && (
                                                      <View key={m.key} style={style_templates.app_sub_container_header_row_container_box}>
                                                            {     temp_array.length != 0 &&  (
                                                                        <Text style={style_templates.dashboard_text_label}>{temp_array.find((s) => s.fieldapiname === m.apiname).value}</Text>     
                                                            )}
                                                      </View>
                                                )}
                                          </>
                                    ))}
                              </View> */}

                              {/* <View style={style_templates.app_sub_container_header_row_container}>
                                    {variables.screen2_metrics_row_2.map((m) => (
                                          <>
                                                {      ( m.metric ==  dataCtx.currentMetric || m.metric == "") && (
                                                      <View key={m.key} style={style_templates.app_sub_container_header_row_container_box}>
                                                            {temp_array.length != 0 && m.metric ==  dataCtx.currentMetric && (
                                                                  <Text style={style_templates.dashboard_text_label}>
                                                                        {temp_array.find((s) => s.fieldapiname === m.apiname).value}
                                                                  </Text>
                                                            )}
                                                      </View>
                                                )}
                                          </>    
                                    ))}
                              </View> */}
{/* 
                              <View style={style_templates.app_sub_container_header_row_container}>
                                    {filteritems_array.map((f) => (
                                          <>
                                                {     f.value.length != 0 && (
                                                            f.value.map( (fa) => (
                                                                  <View key={fa.key} style={style_templates.app_sub_container_header_row_container_box}>
                                                                        <Pressable>
                                                                              <Text style={style_templates.dashboard_text_label}>
                                                                                    {fa.sfname}
                                                                              </Text>
                                                                        </Pressable>
                                                                  </View>
                                                            ))
                                                      )
                                                }
                                          </>    
                                    ))}
                              </View> */}
                        </>
                  </View>
            <View style={[style_templates.app_sub_container, {marginTop:10, flex:6, orderTopWidth:3, borderTopColor: "#d3d3d3",}]}>
                    <FlatList
                      showsVerticalScrollIndicator={false}
                  //     scrollEnabled
                      data={dataCtx.cardListData}
                      keyExtracttor={(item) => item.id}
                      renderItem={renderCards}
                    />
            </View>
            <View style={[style_templates.bottom_nav_bar, {flex:1}]}>
                  <View style={{marginLeft:140,marginRight:140, marginTop:10}}>
                        {/* <Button onPress={() => {console.log('pressed back button')}} title="Back"></Button> */}
                        <Button onPress={backToSummaryScreen} title="Back"></Button>
                  </View>
            </View>
      </View>


    </View>

  )

}

export default LotsListScreen
